import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import des traductions
import enTranslation from "./locales/en.json";
import frTranslation from "./locales/fr.json";
import ruTranslation from "./locales/ru.json";
import arTranslation from "./locales/ar.json";

const resources = {
  en: {
    translation: enTranslation,
  },
  fr: {
    translation: frTranslation,
  },
  ru: {
    translation: ruTranslation,
  },
  ar: {
    translation: arTranslation,
  },
};

i18n
  // Détecte la langue du navigateur
  .use(LanguageDetector)
  // Passe l'instance i18n à react-i18next
  .use(initReactI18next)
  // Initialise i18next
  .init({
    resources,
    fallbackLng: "fr",
    debug: process.env.NODE_ENV === "development",

    interpolation: {
      escapeValue: false, // non nécessaire pour React
    },

    // Options de détection de langue
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
